import { Pipe, PipeTransform } from "@angular/core";
import { LineItem, ProductSubType } from "@acepteam/payment";

@Pipe({
  name: "lineItemsByProductSubType"
})
export class LineItemsPipe implements PipeTransform {
  transform(items: LineItem[], args: string = "MEMBERSHIP"): any {
    let PRODUCT_EMRAALUMNI: string = "EAAL";

    if (!items || !args) {
      return items;
    }

    let membership_ProductSubTypes: ProductSubType[] = [
      ProductSubType.NationalDues,
      ProductSubType.ChapterDues
    ];

    let itemsTransformed = [];
    if (args == "MEMBERSHIP") {
      //NATIONAL DUES
      let nationaDues = items.filter(
        a =>
          a.ProductSubType == ProductSubType.NationalDues &&
          a.ProductNumber != PRODUCT_EMRAALUMNI
      );
      //PRIMARY CHAPTER
      let primaryChapter = items.filter(
        a => a.ProductSubType == ProductSubType.ChapterDues && a.IsPrimary
      );

      if (!primaryChapter) {
        primaryChapter = [];
      }

      itemsTransformed.push(...nationaDues, ...primaryChapter);
    } else {
      // O P T I O N A L *** P R O D U C T S

      //EMRA ALUMNI
      let emraAlumni = items.filter(a => a.ProductNumber == PRODUCT_EMRAALUMNI);

      if (!emraAlumni) {
        emraAlumni = [];
      }

      //SECONDARY CHAPTERS
      let secondaryChapters = items.filter(
        a => a.ProductSubType == ProductSubType.ChapterDues && !a.IsPrimary
      );

      //SECTIONS
      let sections = items.filter(a => a.ProductSubType == ProductSubType.SECT);

      // let itemsTransformed_NotModifiable: LineItem[] = items.filter(
      //   a => a.Modifiable
      // );

      //items like donations that have text box showing up on the right to enter price
      let itemsTransformed_Modifiable: LineItem[] = items.filter(
        a =>
          a.Modifiable &&
          a.ProductSubType != ProductSubType.NationalDues &&
          a.ProductSubType != ProductSubType.ChapterDues
      );

      itemsTransformed.push(
        ...emraAlumni,
        ...secondaryChapters,
        ...sections,
        ...itemsTransformed_Modifiable
      );
    }

    return itemsTransformed;
  }
}
